<template>
<!-- 审核状态-危机逃脱 -->
  <transition name="fade">
    <div class="project" :style="{transform:is_ie}" v-drag>
      <div role="document">
        <div class="modal-content" >
          <div class="modal-header">         
            <span class="modal-title">审核状态</span>
            <!-- <span class="modal-title">{{value}}</span> -->
            <span aria-hidden="true" class="modal-span" @click="close">&times;</span>  
          </div>
          <div class="modal-body" @scroll="table_cont">
           <p style="margin-top:10px;font-size:14px;color:#007bff">不通过原因:</p>
            <textarea name="" id="" cols="30" rows="10" style="width:100%;outline: none;" v-model="rich_text"></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-default-close" data-dismiss="modal" @click="approved">审核通过</button>
            <button type="button" class="btn btn-default-determine" @click="audit_failed">审核不通过</button>
          </div>
          <!-- 加载状态 -->
          <!-- <div class="loading" v-if="anate"><i class="fa fa-spin fa-spinner"></i></div> -->
        </div>
      </div>
    </div>
     <!-- 提示组件 -->
	<tips v-if="sel_tips" :current_state="current_state" :language_pack="language_pack"></tips>
  </transition>
</template>
<script>
  import { mapState } from 'vuex';
  import api from "../api/index.js";
  import tips from "./tips.vue"
  export default {
    name: 'Project',
    components: {
      tips
    },
    computed:{
    //   head_title(){
    //     return '--'+this.$attrs.language_pack[this.sel_language].select_distribution_package+'--'
    //   },
      confirm(){
        return this.$attrs.language_pack[this.sel_language].confirm
      },
      cancel(){
        return this.$attrs.language_pack[this.sel_language].cancel
      },
      ...mapState({
        sel_language:'sel_language'
      })
    },
    data(){
      return {
        //文本内容
        rich_text:'',
        //错误提是信息
        current_state:'',
        //是否显示提是组件
        sel_tips:false,
        //距离头部的位置
        tans_late:'',
        //加载状态
        // anate:true,
        //复选框的数组
        // check_data:[],
        //获取的弹框数据
        list_data:[],
        //单选按钮
        list_radio:false,
        //头部数据
        // show_data:null,
        //计数
        // count:0,
        // head_data:[],
        // rows:null,
        //标题
        // value:'',
        //是否是ie
        is_ie:false,
        num:[0,1]
      }
    },
    mounted(){
    //获取数据
    //   this.get_data(this.key_s.Name);
      this.selected_data()
      //判断是不是ie
      this.t_ie()
    //   console.log(this.rule_data)
    },
    props:[
      //有弹框的头部字段（根据此字段判断是否有弹框）
      'ppr_action',
      //有弹框的数据头部字段
      'ppr_action_param',
      //弹框中的函数
      'box_fun',
      //输入框中的值
      'rule_data',
      'key_s'
    ],
    methods:{
      t_ie(){
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          // this.is_ie='translate(-50%, -50%)'
        }
      },
      //捕获异步错误
	  async_error(promise){
	  	return promise.then(res => res).catch(error => this.error_message(error));
	  },
      //错误提示
	  error_message(message){
				this.sel_tips=true;
				this.current_state=message;
				window.setTimeout(()=>{
					this.sel_tips=false;
				},2000)
				this.anate=false;
	  },
      //有值的时候把对应的数据项选中
      selected_data(){
        if(this.rule_data){
            this.rich_text=this.rule_data
        }
      },
      //固定表头
      table_cont(e){
				this.tans_late=e.target.scrollTop;
		  },
      //点击tr元素选中radio标签
      col_radio(data){
        //   alert(0)
        this.list_radio=data;
      },
      //点击关闭图标
      close(){
        this.$emit('close_project')
      },
      //审核不通过
      audit_failed(){
        this.$emit('audit_failed',this.rich_text)
      },
      //审核通过
      approved(){
        this.$emit('approved') 
        },
    },
    directives: {
      drag: {
        inserted(el) {
          let drag_Box = el; //获取当前元素
          let dragBox = document.getElementsByClassName('modal-header')[0];
          dragBox.onmousedown = e => {
              //算出鼠标相对元素的位置
              let disX = e.clientX - drag_Box.offsetLeft;
              let disY = e.clientY - drag_Box.offsetTop;
              document.onmousemove = e => {
                console.log(1)
                  //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                  let left = e.clientX - disX;
                  let top = e.clientY - disY;
                  //移动当前元素
                  drag_Box.style.left = left + "px";
                  drag_Box.style.top = top + "px";
              };
              document.onmouseup = e => {
                    //鼠标弹起来的时候不再移动
                    document.onmousemove = null;
                   //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
                  document.onmouseup = null;
              };
          };
        }
      }
    }
  }
</script>
<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .th{
    background: white;
  }
  .fa-spin{
	    -webkit-animation: fa-spin 1s infinite linear;
      animation: fa-spin 1s infinite linear;
	}
  .modal-footer{
    justify-content: space-between;
  }
	.loading{
		z-index: 1000;
		font-size: 50px;
		position: absolute;
		color: rgb(138, 132, 132);
		top: 50%;
		left: 50%;
		/* transform: translate(-50%, -50%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
		text-align: center;
	}
  .modal-header{
    cursor: move;
  }
  .modal-body{
    max-height: 500px;
    overflow: auto;
    padding-top: 0;
  }
  .table>tbody>tr>td {
    text-align: center;
  }
  .table>thead>tr>th {
    text-align: center;
  }
	.project{
    min-width: 846px;
    position: fixed;
    top: 50%;
    left: 50%;
    height: 500px;
    z-index:999;
    transform: translate(-50%, -50%);
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  /* transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px)); */
  }
 .modal-header{
		background:#ebecf0;
		height:40px
	}
 .modal-span{
		font-size:20px;
		margin-top:-14px;
		cursor:pointer
	}
	.modal-title{
		line-height:1px
	}
  .btn-default-close{
    color:#007bff;
		font-size:12px;
		border:1px solid #808080;
		padding:4px;
		/* margin-right: 90%; */
  }
  .btn-default-determine{
    color:#007bff;
		font-size:12px;
		border: 1px solid rgb(128, 128, 128);
		padding: 4px;
  }
  td{
    font-size: 12px;
  }
</style>